<template>
  <ol class="breadcrumbs">
    <li>
      <router-link :to="{name:'dashboard'}">
        <img src="@/assets/img/apps_logo.svg" :alt="$t('title')" />
      </router-link>
    </li>
    <li v-for="link in visibleLinks">
      <router-link v-if="typeof link === 'object'" :to=link>
        {{ link.title || '' | text }}
      </router-link>
      <span v-if="typeof link === 'string'">
        {{ link | text }}
      </span>
    </li>
    <li class="user" ref="toprightmenu">
      <a @click="menuopen = !menuopen">
        <span>{{ user | text }}</span>
        <small v-if="admintoken">
          ({{ 'apptokens:admin.as' | trans }}
          {{ admintoken.company_name | text }})
        </small>
        <Icon name="cog" />
      </a>
      <nav v-show="menuopen">
        <span>
          <languages />
        </span>
        <router-link v-if="$store.getters.admin" :to="{name: 'apptokens.select'}" @click.native=clicked>
          {{ 'apptokens:admin.choose' | trans }}
        </router-link>
        <a v-else :href="accountlink" @click=clicked>{{ "titles.profile" | trans }}</a>
        <router-link :to="{name: 'apptokens.edit'}" @click.native=clicked>{{ "titles.apptokens" | trans }}</router-link>
        <a :href="toslink" target="_blank" @click=clicked>{{ "terms" | trans }}</a>
        <a v-on:click.left="logout" @click.native=clicked>{{ "logout" | trans }}</a>
      </nav>
    </li>
  </ol>
</template>

<script>
  import _ from 'lodash';
  import {routeName} from '@/providers/routing'
  import {event_hit} from '@/helpers/util'
  
  export default {
    data () {return {
      currentRoute: this.$router.currentRoute,
      menuopen: false,
    }},
    computed: {
      accountlink () {
        return ENV.API_LOCATION.rtrim('/') + '/' +
          'accounts/' +
          this.$i18n.i18next.language
        ;
      },
      toslink () {
        return ENV.API_LOCATION.rtrim('/') + '/' +
          'v1/' +
          this.$i18n.i18next.language + '/' +
          'tos'
        ;

      },
      visibleLinks () {
        this.$nextTick(this.documentTitle);
        return this.links.filter(link => (link && typeof link === 'string') || (typeof link === 'object' && link.title));
      },
      links () {
        var links = [];
        if (!this.$route) {
          return [];
        }

        //get title from route or route's component instance
        var completeRoute = route => {
          let rt = _.pick(route, ['name', 'params', 'meta', 'path']);
          if (!_.has(route, 'meta')) {
            route.meta = {};
          }
          if (_.has(route, 'meta.icon')) {
            rt.icon = route.meta.icon;
          }
          rt.title = routeName(route);
          return _.clone(rt);
        };

        //routes should be listed top-up (root first)
        var getParentRoutes = routes => {
          var ret = [];
          for (let rkey = routes.length-1; rkey >= 0; rkey--) {
            var current = routes[rkey];
            ret.push(completeRoute(current));
            //meta.up breaks the chain
            if (_.has(current, 'meta.up') && typeof current.meta.up === 'string') {
              var resolved = this.$router.resolve({name: current.meta.up}).resolved.matched || [];
              ret = ret.concat(getParentRoutes(resolved.filter(r => {
                return !r.path || r.path !== current.path;
              })));
              break;
            }
          }
          return ret;
        };
        return _.reverse(getParentRoutes(this.$route.matched));
      },
      user () {
        var user = this.$store.getters.user;
        return user.name + ' ' + user.lname;
      },
      admintoken () {
        if (this.$store.getters.admin && this.$store.getters.apptoken && this.$store.getters.apptoken.length) {
          return this.$store.getters.apptoken;
        }
      },
    },
    methods: {
      documentTitle () {
        var lasttitle = false;
        if (this.visibleLinks.length) {
          var lastlink = this.visibleLinks[this.visibleLinks.length - 1];
          if (typeof lastlink === 'string') {
            lasttitle = lastlink;
          }
          if (typeof lastlink === 'object' && lastlink.title) {
            lasttitle = lastlink.title;
          }
        }
        var fulltitle = 'Enkronos Apps';
        if (lasttitle) {
          fulltitle = lasttitle + ' - ' + fulltitle;
        }
        document.title = fulltitle;
      },
      logout: function () {
        this.$store.commit('logout');
      },
      clicked () {
        this.menuopen = false;
      },
      listener (evt) {
        if (event_hit(evt, this.$refs.toprightmenu)) {
          return;
        }
        this.menuopen = false;
      },
    },
    mounted () {
      document.addEventListener('click', this.listener);
    },
    beforeDestroy () {
      document.removeEventListener('click', this.listener);
    }
  }
</script>

<style lang="scss">
  ol.breadcrumbs {
    position: fixed;
    z-index: 3;
    top: 0;
    left: 0;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 0;
    background: white;
    box-shadow: 0 0 18px 0 $inverse-border;
    @media (min-width: $md-min) {
      white-space: nowrap;
    }
    li {
      display: inline-block;
      white-space: nowrap;
      margin: 0;
      @include font-size(22px, 1.6);
      padding: #{($breadcrumbs-height - 1.6*22px) / 2} 35px;
      text-align: center;
      position: relative;
      overflow: hidden;
      &::after {
        content: '\00A0';
      }
      /*TITLE (Enkronos Apps=)*/
      &:first-child {
        $pad: 7px;
        border-right: solid $inverse-border 3px;
        width: $mainmenu-width;
        background: white;
        padding: $pad 0 0;
        img {
          height: #{$breadcrumbs-height - 2*$pad};
          vertical-align: text-bottom;
          @media (max-width: $xs-max) {
            width: 140px;
          }
        }
      }
      /*This applies arrows left of every breadcrumb apart from first one*/
      &:nth-child(n+3):not(:last-child) {
        @media (min-width: $md-min) {
          padding-left: 70px;
          a::before {
            content: '';
            display: inline-block;
            position: absolute;
            width: $breadcrumbs-height - 8px;
            height: $breadcrumbs-height - 8px;
            top: 0;
            left: -$breadcrumbs-height/2;
            border: solid $inverse-border 4px;
            transform-origin: center;
            transform: rotate(45deg);
          }
        }
      }
      /*Last link is profile*/
      &:last-child {
        float: right;
        @media (min-width: $md-min) {
          position: absolute;
          top: 0;
          right: 0;
        }
        padding-right: 0;
        margin-right: $gutter;
        overflow: visible;
        .svg-icon {
          margin-left: 1em;
        }
      }
      .svg-icon {
        vertical-align: middle;
        transform: scale(1.2);
      }
      a {
        cursor: pointer;
      }
      /*Dropdown menu (for last link))*/
      > nav {
        position: absolute;
        z-index: 1;
        right: 0;
        top: 100%;
        box-shadow: 0 0 18px 0 $inverse-border;
        min-width: 240px;
        > a, > span {
          text-align: left;
          display: block;
          padding: 5px 20px;
        }
        > span > select {
          width: 100%;
        }
      }
      /*MIDDLE SCREENS*/
      @media (max-width: $md-max) {
        /*Show just last 2 breadcrumbs*/
        &:not(:first-child):not(:last-child):not(:nth-last-child(2)):not(:nth-last-child(3)) {
          display: none;
        }
        &:nth-last-child(3):not(:last-child) {
          padding-left: 30px;
          a::before {
            content: none;
          }
        }
      }
      /*SMALL SCREENS*/
      @media (max-width: $sm-max) {
        display: none;
        padding-left: 0;
        padding-right: 0;
        /*title (logo) is in the middle*/
        &:first-child {
          display: block;
          width: 100vw;
          border: none;
          text-align: center;
        }
        /*only show profile link and before-last link*/
        &:last-child, &:nth-last-child(3):not(:first-child) {
          display: inline-block;
          position: absolute;
          top: 0;
        }
        /*last link (profile) is on the right*/
        &:last-child {
          right: $gutter;
          margin-right: 0;
          @media (max-width: $xs-max) {
            span {
              display: none;
            }
          }
        }
        /*Show before-last breadcrumb (kind of back button)
          it sticks to the left*/
        //Niko said it's confusing
        &:nth-last-child(3):not(:first-child) {
          display: none;
          /*left: $gutter + $breadcrumbs-height; //add space for menu opener on the left
          padding-left: 0;
          //show 'back' arrow
          a::before {
            display: inline-block;
            width: 24px;
            height: 24px;
            transform: scaleX(-1) translateX(10px);
            vertical-align: middle;
            content: '';
            @include svg-bg(arrow);
          }
          .svg-icon {
            display: none;
          }
          //hide text, keep just icons for mobile
          @media (max-width: $xs-max) {
            width: 24px;
            overflow: hidden;
          }*/
        }
      }
    }
    @include paint_breadcrumbs($default-bg, $accent-color, $accent);
  }
</style>



// WEBPACK FOOTER //
// src/Breadcrumbs.vue